"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _size = require("../../constants/size");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var getSize = function getSize(_ref) {
  var theme = _ref.theme,
    size = _ref.size;
  switch (size) {
    case _size.SMALL:
      return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        height: ", ";\n        width: ", ";\n        min-width: ", ";\n        min-height: ", ";\n      "])), theme.sizeSmall, theme.sizeSmall, theme.sizeSmall, theme.sizeSmall);
    case _size.LARGE:
    default:
      return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        height: ", ";\n        width: ", ";\n        min-width: ", ";\n        min-height: ", ";\n      "])), theme.sizeLarge, theme.sizeLarge, theme.sizeLarge, theme.sizeLarge);
  }
};
var _default = getSize;
exports["default"] = _default;